import { AxiosError } from "axios";
import { z } from "zod";

const apiInfoSchema = z.object({
  code: z.number(),
  message: z.string(),
  errorCode: z.number(),
});

const isAxiosError = (e: unknown): e is AxiosError => e instanceof AxiosError;

export const isErrorWithCode = (e: unknown, errorCode: number) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorData = isAxiosError(e) ? (e.response?.data as any)?.info : e;
  const errorInfo = apiInfoSchema.safeParse(errorData);

  if (!errorInfo.success) return false;
  return errorInfo.data.errorCode === errorCode;
};
export const isErrorWithMessage = (e: unknown, message: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorData = isAxiosError(e) ? (e.response?.data as any)?.info : e;
  const errorInfo = apiInfoSchema.safeParse(errorData);

  if (!errorInfo.success) return false;
  return errorInfo.data.message === message;
};

export const isForbiddenError = (e: unknown) =>
  isErrorWithCode(e, 403) || isErrorWithStatus(e, 403);

export const isErrorWithStatus = (e: unknown, statusCode: number) => {
  const errorData = isAxiosError(e) ? e.response : e;
  const result = z.object({ status: z.number() }).safeParse(errorData);
  if (!result.success) return false;
  return result.data.status === statusCode;
};

type QueryParamable = string | number | boolean;

export const concatQueryParams = (
  baseUrl: string,
  obj: Record<string, QueryParamable | QueryParamable[] | undefined>,
): string => {
  const urlWithQueryParams = `${baseUrl}${
    baseUrl.endsWith("?") ? "" : "?"
  }${Object.entries(obj)
    .reduce((acc, [key, val]) => {
      if (!val) return "";
      if (Array.isArray(val)) {
        return `${acc}&${val
          .map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`)
          .join("&")}`;
      }
      return `${acc}&${`${encodeURIComponent(key)}=${encodeURIComponent(
        val,
      )}`}`;
    }, "")
    .substring(1)}`;
  return urlWithQueryParams.endsWith("?")
    ? urlWithQueryParams.slice(0, -1)
    : urlWithQueryParams;
};
